
import { Component, Vue, Prop } from "vue-property-decorator"
import { Formatting } from "../../util/formatting"
const dateFormat = new Formatting.DateFormatting()
const constants = new Formatting.Constants()

import * as cdn from "@coredination/components"

import EntityEventSubscription from "@/graphql/subscription/entityevent.graphql"
import CustomerDetailQuery from "@/graphql/customer/customerdetail.graphql"
import CustomerJobsQuery from "@/graphql/job/customerjobs.graphql"
import CountJobs from "@/graphql/job/countJobs.graphql"

@Component({
    components: {
        JobList: () => import("@/components/misc/JobList.vue"),
    },
    apollo: {
        me: cdn.graphql.me,
        customer: {
            query: CustomerDetailQuery,
            skip() {
                return !this.uuid
            },
            variables() {
                return { uuid: this.uuid }
            }
        },
        customerJobs: {
            query: CustomerJobsQuery,
            variables() {
                return {
                    uuid: this.uuid,
                    states: this.defaultJobStates,
                    offset: this.offset,
                    limit: constants.jobsPerPage,
                }
            },
            skip() {
                return !this.uuid
            }
        },
        countJobs: {
            query: CountJobs,
            variables() {
                return {
                    uuid: this.uuid,
                    states: this.defaultJobStates,
                    which: "customer"
                }
            },
            skip() {
                return !this.uuid
            }
        },
        $subscribe: {
            entityEvent: {
                query: EntityEventSubscription,
                result(result: any) {
                    const event = result.data.entityEvent
                    const entityUuid = event.data.uuid
                    if (this.customerJobs.find((job: any) => job.uuid === entityUuid))
                        this.refresh()
                    return
                }
            }
        }
    }
})
export default class CustomerJobList extends Vue {
    @Prop()
    uuid!: string

    me: any = {}
    customer: any = {}
    customerJobs: any[] = []
    from: Date = this.minDateTime(new Date(new Date().setMonth(new Date().getMonth() - 1)))
    to: Date = this.maxDateTime(new Date())
    activeTab: number = 2
    offset: number = 0

    defaultJobStates: string[] = [
        "INITIAL",
        "DRAFT",
        "PUBLISHED",
        "ASSIGNED",
        "SCHEDULED",
        "IN_TRANSIT",
        "ON_STATION",
        "STARTED",
        "PAUSED",
        "DAY_FINISHED",
        "FINISHED",
        "CANCELED",
    ]

    updateOffset(offset: any) {
        this.offset = offset
    }

    updateFrom(date: Date) {
        this.from = date
    }

    updateTo(date: Date) {
        this.to = date
    }

    dateRange(fromDate: Date, toDate: Date) {
        if (fromDate && toDate) {
            return fromDate.getFullYear() + '-' + dateFormat.datePart(fromDate) + ' - ' + toDate.getFullYear() + '-' + dateFormat.datePart(toDate) 
        }
        return ""
    }

    minDateTime(date: Date) {
        date.setHours(0)
        date.setMinutes(0)
        date.setSeconds(0)
        date.setMilliseconds(0)
        return date
    }

    maxDateTime(date: Date) {
        date.setHours(23)
        date.setMinutes(59)
        date.setSeconds(59)
        date.setMilliseconds(999)
        return date
    }

    refresh() {
        if (this.$apollo.queries.customerJobs &&
            typeof this.$apollo.queries.customerJobs.refetch == "function")
            this.$apollo.queries.customerJobs.refetch()
    }

}
